
import React from 'react';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { ProfileHeader } from '@/components/profile/ProfileHeader';

type ProfileInfoCardProps = {
  profile: any;
  email?: string | null;
  userId?: string;
  isCreatingProfile: boolean;
  isFamilyAdmin: boolean;
  familyAdmin: any;
};

export const ProfileInfoCard: React.FC<ProfileInfoCardProps> = ({
  profile,
  email,
  userId,
  isCreatingProfile,
  isFamilyAdmin,
  familyAdmin,
}) => {
  return (
    <Card>
      <CardHeader className="bg-slate-50 dark:bg-slate-900 pb-2">
        <CardTitle>Profile Information</CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <ProfileHeader
          profile={profile}
          email={email}
          isFamilyAdmin={isFamilyAdmin}
          familyAdmin={familyAdmin}
          userId={userId}
        />
      </CardContent>
    </Card>
  );
};
